import { JobTitle } from "domain/entities/job-title";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useJobTitleByFilter } from "presentation/hooks/use-query-job-title";
import { useJobTitleStore } from "presentation/stores/use-job-title-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const JobTitleDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [jobTitleOptions, setJobTitleOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { jobTitle, setJobTitle } = useJobTitleStore();

  const { data: jobTitles } = useJobTitleByFilter({
    limit: 100,
  } as BaseInputFilter);

  useEffect(() => {
    setJobTitle(jobTitles?.data);
  }, [jobTitles]);

  useEffect(() => {
    setJobTitleOptions(
      jobTitle.map((item: JobTitle) => ({
        label: item.name,
        value: item.name,
      }))
    );
  }, [jobTitle]);

  return (
    <Dropdown
      value={options.value}
      options={jobTitleOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione a função"
      showClear
    />
  );
};
export default JobTitleDropdown;
